import { createFileRoute } from '@tanstack/react-router';
import { RentalReportPage } from '@/features/rentals/pages/rental-report-page';
import { requireRentalShop } from '@/lib/rental-guard';

export const Route = createFileRoute('/_app/rental-report')({
  beforeLoad: requireRentalShop,
  // ?tab=money opens the daily money (cash basis) tab
  validateSearch: (search: Record<string, unknown>): { tab?: 'money' } =>
    search.tab === 'money' ? { tab: 'money' } : {},
  component: RentalReportPage,
});
